import { MDCSelect } from "@material/select";

$(document).on("turbolinks:load", function () {
  var $form = $("form#sign_up_form");
  if ($form.length > 0) {
    var $currentStep = $("input#sign_up_step");
    var $continueButton = $("button#sign_up_continue_btn");
    var $backButton = $("button#sign_up_back_btn");
    var $submitButton = $("input#sign_up_submit_btn");
    var containers = getContainers();

    //---------- check url parameters ----------
    var account = normalizeAccountType(getQueryParameter("account"));
    var token = getQueryParameter("token") || getQueryParameter("claim_hash");
    if (account) setUpAccountTypeInput(account);
    switch (account) {
      case "student":
        $backButton.hide();
        if (token) {
          $currentStep.val(2);
          resetStepContainers(2);
        } else {
          var skipTo = getQueryParameter("skip-to");
          var nextStep = 1;
          if (skipTo === "account-details") {
            nextStep = 2;
          }
          $currentStep.val(nextStep);
          getCustomCategories();
          resetStepContainers(nextStep);
          setupChooseSchoolMenuList();
        }
        break;
      case "administrator":
        $currentStep.val(3);
        resetStepContainers(3);
        setClubContainer(true);
        $backButton.hide();
        break;
      case "district":
        $currentStep.val(3);
        resetStepContainers(3);
        setClubContainer(false);
        $backButton.hide();
        break;
      default:
        $currentStep.val(0);
        resetStepContainers(0);
        break;
    }

    //---------- disable field validations by account type ----------
    $submitButton.on("click", function (e) {
      var valid = checkRequiredInputsByAccountType(
        normalizeAccountType(getQueryParameter("account")),
        true
      );
      if (!valid) {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    //---------- back button handler ----------
    $backButton.on("click", function () {
      scrollToTopPage();
      followStepContainer(
        normalizeAccountType(getQueryParameter("account")),
        currentStep(),
        -1
      );
      setupSubmitOptions("none");
    });

    //---------- continue button handler ----------
    $continueButton.on("click", function () {
      scrollToTopPage();
      var step = currentStep();
      var validStep = triggerInputsValidationByStep(containers[step]);

      if (step === 0) {
        var accountType = containers[0]
          .find('input[type="radio"]:checked')
          .val();
        setQueryParameter("account", accountType);
        checkRequiredInputsByAccountType(accountType, false);
        if (accountType === "student") setupChooseSchoolMenuList();
      }

      if (validStep) {
        followStepContainer(
          normalizeAccountType(getQueryParameter("account")),
          step,
          1
        );
      }
    });

    setUpIsParentSelect();
    if (!getQueryParameter("REFERRALCODE")) {
      setUpOriginSelect();
    }
  }

  let forgotCodeModal = $("#forgot-code-modal");

  $("#forgot-code").on("click", function () {
    $(document.body).css("overflow", "hidden");
    forgotCodeModal.css("display", "block");
  });

  $("#forgot-code-modal-close").on("click", function () {
    $(document.body).css("overflow", "auto");
    forgotCodeModal.css("display", "none");
    $("#origin_referral_reference").val(null);
  });

  $("#forgot-code-modal-save").on("click", function () {
    $(document.body).css("overflow", "auto");
    forgotCodeModal.css("display", "none");
  });

  $(window).on("click", function (event) {
    if (event.target === forgotCodeModal.get(0)) {
      $(document.body).css("overflow", "auto");
      forgotCodeModal.css("display", "none");
      $("#origin_referral_reference").val(null);
    }
  });
});

//-----------------------methods--------------------------//
function scrollToTopPage() {
  window.scrollTo(0, 0);
}

function removeMenuListChildren($select) {
  var $oldChildren = $($select).find("li");
  $oldChildren.remove();
}

function fillMenuList($select, options, key, value) {
  removeMenuListChildren($select);
  options.forEach((option) => {
    var row = `<li class="mdc-list-item" data-value="${option[key]}" role="option" tabindex="0">${option[value]}</li>`;
    $select.insertAdjacentHTML("beforeend", row);
  });
}

function fillMenuListWithDataAttr(
  $select,
  options,
  key,
  value,
  data,
  rewardCenterData
) {
  removeMenuListChildren($select);
  options.forEach((option) => {
    var row = `<li class="mdc-list-item" data-value="${option[key]}" data-${data}="${option[data]}" data-has_reward_center="${option["reward_center"]}" tabindex="0">${option[value]}</li>`;
    $select.insertAdjacentHTML("beforeend", row);
  });
}

function fillCityMenuList(stateId, $select, collection) {
  var options = collection[stateId.toString()] || [];
  fillMenuList($select, options, "city", "city");
}

function fillOrganizationMenuList(cityName, $select, collection) {
  var options = collection[cityName.toString()] || [];
  fillMenuListWithDataAttr(
    $select,
    options,
    "id",
    "name",
    "is_club",
    "reward_center"
  );
}

function getContainers() {
  return [
    $("div#step_0_container"),
    $("div#step_1_container"),
    $("div#step_2_container"),
    $("div#step_3_container"),
  ];
}

function currentStep() {
  return parseInt($("input#sign_up_step").val());
}

function setQueryParameter(key, value) {
  var url = new URL(window.location.href);
  url.searchParams.set(key, value);
  window.history.replaceState(null, null, url);
}

function getQueryParameter(param) {
  var urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

function normalizeAccountType(account) {
  return account === "chairperson" ? "administrator" : account;
}

function followStepContainer(account, step, direction) {
  let followStep;
  var $backButton = $("button#sign_up_back_btn");
  $backButton.show();
  $("button#sign_up_continue_btn").show();

  if (account === "student") {
    followStep = step + direction;
    if (direction === -1 && step === 1) {
      $backButton.hide();
    } else if (direction === 1 && step === 1) {
      getCustomCategories();
      setupSubmitOptions("block");
    }
  } else if (direction === 1 && step === 0) {
    followStep = 3;
    $backButton.hide();
    setupSubmitOptions("block");
    setClubContainer(account === "administrator");
  }

  var containers = getContainers();
  containers[step].hide();
  containers[followStep].show();
  $("input#sign_up_step").val(followStep);
}

function getCustomCategories() {
  const schoolId = $("input[name='user\\[student\\[school_id\\]\\]']").val();
  const host = window.location.host;
  const basePath = window.location.pathname.split("/")[1];
  $.ajax({
    url: `//${host}/${basePath}/schools/${schoolId}/campaign_custom_categories`,
    type: "GET",
    success: function (data) {
      const customCategoriesDiv = document.querySelector("#custom-categories");
      if (!data.length) {
        customCategoriesDiv.innerHTML = "";
        return;
      }

      const v2Fields = customCategoriesDiv.querySelectorAll(".v2-field");
      data.forEach(function (category, i) {
        if (i >= 3) return;
        const label = v2Fields[i].querySelector(".mdc-floating-label");
        label.textContent =
          category.name.charAt(0).toUpperCase() +
          category.name.slice(1).toLowerCase();

        const input = document.createElement("input");
        input.type = "hidden";
        input.name = "user[student[categories[][id]]";
        input.value = category.id;
        v2Fields[i].appendChild(input);

        const options = v2Fields[i].querySelector(".mdc-select__menu");
        options.innerHTML = "";
        const ul = document.createElement("ul");
        ul.classList.add("mdc-list");
        category.campaign_custom_category_options.forEach(function (option) {
          const li = document.createElement("li");
          li.classList.add("mdc-list-item");
          li.dataset.value = option.id;
          li.textContent = option.name;
          li.setAttribute("role", "option");
          ul.appendChild(li);
        });
        options.appendChild(ul);
        new MDCSelect(v2Fields[i].querySelector(".mdc-select"));
      });

      if (data.length < v2Fields.length) {
        for (let i = data.length; i < v2Fields.length; i++) {
          v2Fields[i].remove();
        }
      }
    },
    error: function (error) {
      console.log(error);
    },
  });
}

function resetStepContainers(step) {
  setupSubmitOptions("none");
  var containers = getContainers();
  containers.forEach((container) => {
    container.hide();
  });

  if (step === 0) {
    $("button#sign_up_back_btn").hide();
  } else if ([2, 3].includes(step)) {
    setupSubmitOptions("block");
  }
  containers[step].show();
}

function setUpAccountTypeInput(account) {
  getContainers()[0]
    .find(`input#account_type_${account}`)
    .prop("checked", true);
}

function setupSubmitOptions(display) {
  let switchDisplay;
  if (display === "none") {
    switchDisplay = "block";
    $(".actions").addClass("end");
  } else {
    switchDisplay = "none";
    $(".actions").removeClass("end");
  }

  $("a#video_guidelines_link").css("display", display);
  $("div#privacy_terms_field").css("display", display);
  $("input#sign_up_submit_btn").css("display", display);
  $("button#sign_up_continue_btn").css("display", switchDisplay);
}

function setupChooseSchoolMenuList() {
  if (typeof itemCollections !== undefined) {
    var stateSelect = new MDCSelect(
      document.querySelector(
        "div.mdc-select[data-element-type='address[state_id]']"
      )
    );
    var citySelect = new MDCSelect(
      document.querySelector("div.mdc-select[data-element-type='address[id]']")
    );
    var schoolSelect = new MDCSelect(
      document.querySelector(
        "div.mdc-select[data-element-type='user[student[school_id]]']"
      )
    );
    var gradeSelect = new MDCSelect(
      document.querySelector(
        "div.mdc-select[data-element-type='user[student[grade]]']"
      )
    );

    stateSelect.listen("MDCSelect:change", function (data) {
      fillCityMenuList(
        data.detail.value,
        citySelect.menu.list_.root,
        itemCollections.cities
      );
    });

    citySelect.listen("MDCSelect:change", function (data) {
      fillOrganizationMenuList(
        data.detail.value,
        schoolSelect.menu.list_.root,
        itemCollections.organizations
      );
    });

    schoolSelect.listen("MDCSelect:change", function (data) {
      var $optionSelected = schoolSelect.menu.items[data.detail.index];
      $("input#student_school_name").val($optionSelected.textContent);
      var isSchool = $optionSelected.dataset.is_club === "false";
      var hasRewardCenter =
        $optionSelected.dataset.has_reward_center === "true";
      if (isSchool) {
        gradeSelect.required = true;
      } else {
        gradeSelect.required = false;
      }
      if (!hasRewardCenter || true) {
        $(".rewards_center_modal").hide();
      }
    });
  }
}

function checkRequiredInputsByAccountType(accountType, onSubmit) {
  let $noRequiredFields, $requiredFields, valid;
  var $studentContainers = $("div#step_1_container, #step_2_container");
  var $adminContainer = $("div#step_3_container");

  if (onSubmit) {
    if (accountType === "student") {
      valid = triggerInputsValidationByStep($("div#step_2_container"));
      $noRequiredFields = $adminContainer.find("[required='required']");
    } else {
      valid = triggerInputsValidationByStep($("div#step_3_container"));
      $noRequiredFields = $studentContainers.find("[required='required']");
    }
    $noRequiredFields.each((_index, field) => {
      field.setAttribute("disabled", "");
    });
    return valid;
  } else {
    if (accountType === "student") {
      $requiredFields = $studentContainers.find("[required='required']");
    } else {
      $requiredFields = $adminContainer.find("[required='required']");
    }
    $requiredFields.each((_index, field) => {
      field.removeAttribute("disabled");
    });
  }
}

function setUpOriginSelect() {
  var originSelect = new MDCSelect(
    document.querySelector("div.mdc-select[data-element-type='origin[origin]']")
  );
  var representativeSelect = new MDCSelect(
    document.querySelector(
      "div.mdc-select[data-element-type='origin[rep_email]']"
    )
  );
  var $representativeName = $("input#origin_rep_name");
  var $referralCode = $("input#origin_referral_code");
  var $forgotCode = $("small#forgot-code");

  originSelect.listen("MDCSelect:change", function (data) {
    $representativeName.val(null);
    representativeSelect.root.style.display = "none";
    representativeSelect.layout();
    representativeSelect.required = false;
    $referralCode.val(null);
    $referralCode.hide();
    $forgotCode.css("display", "none");

    if (data.detail.value == "TMF Sales Rep") {
      representativeSelect.required = true;
      representativeSelect.root.style.display = "block";
    } else if (data.detail.value === "Referral") {
      $referralCode.show();
      $forgotCode.css("display", "flex");
    }
  });

  representativeSelect.listen("MDCSelect:change", function (data) {
    var $optionSelected = representativeSelect.menu.items[data.detail.index];
    $representativeName.val($optionSelected.textContent);
  });
}

function setUpIsParentSelect() {
  var roleSelect = new MDCSelect(
    document.querySelector(
      "div.mdc-select[data-element-type='user[is_parent]']"
    )
  );
  roleSelect.listen("MDCSelect:change", function (data) {
    var isParent = data.detail.value;
    var $birthdayInput = $("input#student_birthday");
    var $birthdayFieldGroup = $(".student-birthday-field-group");
    var $gradeSelect = $(
      "div.mdc-select[data-element-type='user[student[grade]]']"
    );
    let $customCategories = $("#custom-categories");

    if (isParent === "true") {
      $birthdayInput.attr("disabled", "");
      $birthdayFieldGroup.hide();
      $gradeSelect.removeClass("mdc-select--required");
      $gradeSelect.parent().hide();
      const categories = $customCategories.find("div.mdc-select");

      if (categories.length) {
        categories.each((index, category) => {
          $(category).removeClass("mdc-select--required");
        });
      }
      $customCategories.hide();
    } else {
      $birthdayFieldGroup.show();
      $birthdayInput.removeAttr("disabled");
      $gradeSelect.parent().show();
      $gradeSelect.addClass("mdc-select--required");
      $customCategories.show();
      const categories = $customCategories.find("div.mdc-select");
      if (categories.length) {
        categories.each((index, category) => {
          $(category).addClass("mdc-select--required");
        });
      }
    }
  });
}

function triggerInputsValidationByStep(container) {
  let valid, current;
  var $requiredFields = container.find("[required='required']");
  $requiredFields.each((_index, field) => {
    current = field.value.trim();
    field.value = current;
    field.reportValidity();
    valid = field.checkValidity();
    return valid;
  });

  if (valid === false) return valid;

  valid = triggerPhoneInputsValidationByStep(container);
  if (valid === false) return valid;

  var $requiredFieldsMDC = container.find(".mdc-select--required");
  if ($requiredFieldsMDC.length > 0) {
    $requiredFieldsMDC.each((_index, field) => {
      valid = field.querySelector("input").value.trim() !== "";
      if (!valid && !field.classList.contains("mdc-select--invalid")) {
        field.classList.add("mdc-select--invalid");
      }
      return valid;
    });
  }
  return valid;
}

function triggerPhoneInputsValidationByStep(container) {
  var valid = true;
  var phoneInstances = window.itis || {};

  container.find("input[type='tel']").each((_index, field) => {
    var value = field.value.trim();
    var instance = phoneInstances[field.id];
    if (!value || !instance) return true;

    var $errorMsg = $(`#error-msg-${field.id}`);
    var $validMsg = $(`#valid-msg-${field.id}`);
    field.classList.remove("error");
    field.setCustomValidity("");
    $errorMsg.html("");
    $errorMsg.prop("hidden", true);
    $validMsg.prop("hidden", true);

    if (instance.isValidNumber()) {
      field.value = instance.getNumber();
      $validMsg.prop("hidden", false);
      return true;
    }

    field.classList.add("error");
    var errorCode = instance.getValidationError();
    var phoneErrorMap = window.errorMap || [
      "Invalid number",
      "Invalid country code",
      "Too short",
      "Too long",
      "Invalid number",
    ];
    var errorMessage = phoneErrorMap[errorCode] || phoneErrorMap[0];
    field.setCustomValidity(errorMessage);
    $errorMsg.html(errorMessage);
    $errorMsg.prop("hidden", false);
    field.reportValidity();
    valid = false;
    return false;
  });

  return valid;
}

function setClubContainer(show) {
  var $adminContainer = getContainers()[3];
  var $clubContainer = $adminContainer.find("div.field.club-container");
  if (show) {
    $clubContainer.find("input").removeAttr("disabled");
    $clubContainer.show();
  } else {
    $clubContainer.find("input").attr("disabled", "");
    $clubContainer.hide();
  }
}
